import script from "./addPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./addPayment.vue?vue&type=script&setup=true&lang=js"

import "./addPayment.vue?vue&type=style&index=0&id=d92eec08&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d92eec08"]])

export default __exports__